/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlayByPlayModelDto } from '../../models/play-by-play-model-dto';

export interface GameTrackerPublicControllerGetGamePbpById$Params {
  userUuid: string;
  localId: string;
  accessHash: string;
  pbpUuid: string;
}

export function gameTrackerPublicControllerGetGamePbpById(http: HttpClient, rootUrl: string, params: GameTrackerPublicControllerGetGamePbpById$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayByPlayModelDto>> {
  const rb = new RequestBuilder(rootUrl, gameTrackerPublicControllerGetGamePbpById.PATH, 'get');
  if (params) {
    rb.path('userUuid', params.userUuid, {});
    rb.path('localId', params.localId, {});
    rb.path('accessHash', params.accessHash, {});
    rb.path('pbpUuid', params.pbpUuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlayByPlayModelDto>;
    })
  );
}

gameTrackerPublicControllerGetGamePbpById.PATH = '/game-tracker-public/user/{userUuid}/games/{localId}/{accessHash}/pbp/{pbpUuid}';
